import React from 'react';
import axios from 'axios';

import { API_PATH_REGISTER } from './constants';

class RestartButton extends React.Component {
  constructor(props) {
    super(props);

    this.restartTheTest = this.restartTheTest.bind(this);
  }

  render() {
    /* With a mark, the button becomes a choice card: the Chinese word for what
       the test measures, then the name, then a line on what it asks. Used where
       the three tests are offered side by side. */
    if(this.props.mark) {
      return(
        <form className="test-choice">
            <button className="test-choice-btn" onClick={(e) => this.restartTheTest(e, this.props.testType)}>
              <span className="test-choice-mark">{this.props.mark}</span>
              <span className="test-choice-title">{this.props.title}</span>
              <span className="test-choice-note">{this.props.note}</span>
            </button>
        </form>
      );
    }

    return(
      <form>
          <button className="btn btn-primary" onClick={(e) => this.restartTheTest(e, this.props.testType)} style={{margin:'5px 5px 5px 5px', fontSize:'22px'}}>
            {this.props.title == null ? 'Retake the test' : this.props.title}
          </button>
      </form>
    );
  }

  restartTheTest(e, testType) {
    e.preventDefault();
    // Register the user in the database
    axios({
        method: 'post',
        url: `${API_PATH_REGISTER}`,
        headers: {'content-type': 'application/json'},
        data: {email: this.props.userEmail, hanziType: this.props.hanziType, testType: testType}
      })
    .then(result => {
        // Start the test
        const registrationStatus = result.data.registrationStatus;
        const userId = parseInt(result.data.userId);
        this.props.onRestartTheTest(e, registrationStatus, userId, testType);
      })
    .catch(error => {});
  }
}

export default RestartButton